import { ICONSS } from "../../../assets/icons/index1";
import { ICONS } from "../../../assets/icons/index";

// Custom status design
export const SEQUENCE_STYLES = {
  10: {
    icon: ICONS?.runningIconWhite,
    bg: "#25C277",
    color: "#ffffff",
    text: "Running",
  },
  13: {
    icon: ICONS?.PausedOrange,
    bg: "#FFF4EB",
    color: "#FF7700",
    text: "Paused",
  },
  20: {
    icon: ICONS?.completedIcon,
    bg: "#4C90F5",
    color: "#ffffff",
    text: "Completed",
  },
};

export const BROADCAST_STATUS = {
  11: {
    icon: ICONS?.runningIconWhite,
    text: "Running",
    color: "#ffffff",
    bg: "#25C277",
    border: "var(--primary)",
  },
  12: {
    icon: ICONS?.completedIcon,
    text: "Completed",
    color: "#FFFFFF",
    background: "#4C90F5",
    bg: "#4C90F5",
    border: "var(--reviewStatus)",
  },
  8: {
    icon: ICONSS?.stoppedIcon,
    alert_icon: ICONS?.alertIconError,
    text: "Stopped",
    color: "#ff543e",
    background: "var(--BG-RED)",
    border: "var(--borderRed)",
  },
};

export const DAILY_MESSAGING_LIMIT = {
  TIER_50: "50",
  TIER_250: "250",
  TIER_1K: "1k",
  TIER_10K: "10k",
  TIER_100K: "100k",
  TIER_UNLIMITED: "Unlimited",
};